var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("router-link", { attrs: { to: _vm.routerLink } }, [
    _c("div", { staticClass: "c-process-teaser t-background-white-grey" }, [
      _c(
        "div",
        { staticClass: "c-process-teaser__content" },
        [
          _c(
            "div",
            [
              _c("can", { attrs: { i: "customize", a: "ProcessTemplate" } }, [
                _vm.processType === "ProcessTemplate"
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "c-process-teaser-content__custom t-text-style-zeta"
                      },
                      [_vm._v("Processmall")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.status === "Unpublished"
                ? _c(
                    "span",
                    {
                      staticClass: "c-process-teaser__status t-text-style-zeta"
                    },
                    [
                      _c("vue-icon", { attrs: { name: "closed-eye" } }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "c-process-teaser-status__text" },
                        [_vm._v("Ej publicerad")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-process-teaser__text-content" },
                [
                  _c("div", {
                    class: {
                      "c-process-teaser__overlay":
                        this.status === "Unpublished" ||
                        (!_vm.$can("manage", "ProcessTemplate") &&
                          _vm.processType === "ProcessTemplate")
                    }
                  }),
                  _vm._v(" "),
                  _c("p"),
                  _c("h3", { staticClass: "t-text-style-gamma" }, [
                    _vm._v(_vm._s(_vm.name))
                  ]),
                  _vm._v(" "),
                  _vm.notifications.length > 0 && _vm.$can("manage", "Process")
                    ? _c("notify-pill", {
                        attrs: { notifications: _vm.notifications }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p"),
                  _vm._v(" "),
                  _c("p", { staticClass: "t-text-style-epsilon" }, [
                    _vm._v(_vm._s(_vm.strippedString.substring(0, 100))),
                    _vm.strippedString.length > 100
                      ? _c("span", [_vm._v("...")])
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("vue-icon", {
            staticClass: "t-margin-left-s",
            attrs: { name: "arrow-right" }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }